import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { formatCurrency } from "../utils/FormatCurrency";
import { addDays, addHours, format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { carregaCobrancasTodas } from "../services/requests/getChargesInfo";
import { useAuth } from "../contexts/AuthInfoContext";
import { FaFile, FaFileExcel, FaFilePdf, FaPaperclip, FaTimesCircle } from "react-icons/fa";
import { toast } from "react-toastify";

function ConstestacaoDialog(props) {
  //const [checkedConfirmaDias,setCheckedConfirmaDias] = useState(false)
  const fileInputRef = useRef();
  const { user_id, provider_id } = useAuth();
  const [cobrancasContestadas, setCobrancasContestadas] = useState([]);
  const [cobrancasContestacao, setCobrancasContestacao] = useState([]);
  const [arquivosContestacao, setArquivosContestacao] = useState([]);
  const [arquivosContestacaoURL, setArquivosContestacaoURL] = useState([]);
  const [justificativa, setJustificativa] = useState("");
  const tipos_aceitos = ["application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

  const colunasCobranca = [
    {
      field: "cobranca_descricao",
      style: { padding: "0.8vh 0.8vh 0.8vh 0.8vh", fontSize: "1.5vh" },
      header: "Descrição",
    },
    {
      field: "cobranca_valor",
      style: { padding: "0.8vh 0.8vh 0.8vh 0.8vh", fontSize: "1.5vh" },
      header: "Valor Original",
      body: (rowData) => formatCurrency(rowData.cobranca_valor),
    },
    {
      field: "data_vencimento_primeiro_boleto",
      style: { padding: "0.8vh 0.8vh 0.8vh 0.8vh", fontSize: "1.5vh" },
      header: "Vencimento",
      body: (rowData) => format(addHours(new Date(rowData.data_vencimento_primeiro_boleto), 3), "dd/MM/yyyy"),
    },
    {
      field: "protesto_status",
      style: { padding: "0.8vh 0.8vh 0.8vh 0.8vh", fontSize: "1.5vh" },
      header: "Status Protesto",
      body: (rowData) => (rowData.protesto_status === "ENVIADO" ? "PROTESTADO" : "EM ABERTO"),
    },
  ];

  function aceiteFooter() {
    return (
      <div>
        {/* <div className="loginCheckbox" style={{textAlign:"center"}}>
                    <Checkbox
                        inputId="binary"
                        className="loginCheckbox pb-[23px]"
                        checked={checkedConfirmaDias}
                        onChange={(e) => setCheckedConfirmaDias(e.checked)}
                        />
                    <label htmlFor="binary" className="text-[2vh]">
                        Concordo com os termos de negociação
                    </label>
                </div> */}
        <div className="mt-[1vh] continueButton w-full grid px-[20px]">
          <Button
            label="Enviar Contestação"
            onClick={() => {
              props.close();
              criaContestacao();
            }}
          />
        </div>
      </div>
    );
  }

  function mudaSelecao(e) {
    setCobrancasContestadas(e.value);
  }

  function handleUpload(e) {
    const type = e.target.files[0].type;
    console.log("UPLOAD TYPE::::", type);
    if (!type.startsWith("image") && !type.startsWith("text"))
      if (!tipos_aceitos.includes(type)) return toast.error("Formato de arquivo inválido");

    setArquivosContestacao([...arquivosContestacao, e.target.files]);
    setArquivosContestacaoURL([...arquivosContestacaoURL, URL.createObjectURL(e.target.files[0])]);
  }

  function removeFile(index) {
    setArquivosContestacao((prevState) => [...prevState.slice(0, index), ...prevState.slice(index + 1)]);
    setArquivosContestacaoURL((prevState) => [...prevState.slice(0, index), ...prevState.slice(index + 1)]);
  }

  async function criaContestacao() {
    console.log({ justificativa, arquivosContestacao, cobrancasContestadas });
  }

  useEffect(() => {
    const buscaCobrancas = async () => {
      const data = await carregaCobrancasTodas({ user_id, provider_id });
      setCobrancasContestacao(data.rows);
    };

    buscaCobrancas();
  }, []);

  return (
    <div className="boletosDialog">
      <Dialog
        visible
        className="boletosDialog"
        onHide={() => props.close()}
        style={{
          height: window.innerWidth > 760 ? "90vh" : "100vh",
          width: window.innerWidth > 760 ? "80vw" : "100vw",
          textAlign: "center",
          // borderRadius: '30px',
          // padding: '10px'
        }}
        draggable={false}
        header="Contestar Débito"
        footer={aceiteFooter}
      >
        <div className="grid w-full">
          <div className="grid lg:flex w-full">
            <div className="p-[2vh] w-full lg:w-1/2 ">
              <DataTable
                value={cobrancasContestacao}
                header="Débitos ativos"
                lazy
                responsiveLayout="scroll"
                selection={cobrancasContestadas}
                onSelectionChange={(e) => mudaSelecao(e)}
              >
                <Column
                  selectionMode="multiple"
                  style={{
                    padding: "0.8vh 0.8vh 0.8vh 0.8vh",
                    fontSize: "1.5vh",
                  }}
                />
                {colunasCobranca.map((column, index) => (
                  <Column
                    key={index}
                    header={column.header}
                    field={column.field}
                    // headerStyle={column.header}
                    body={column.body}
                    style={column.style}
                  />
                ))}
              </DataTable>
            </div>
            <div className="p-[2vh] w-full lg:w-1/2 grid gap-[1vh] h-min items-start">
              <h6>Justifique o porque você acha se tratar de uma cobrança indevida:</h6>
              <textarea
                className="border-[0.2vh] border-blue-700 rounded-md bg-blue-50
                text-[2vh] h-[20vh] font-lato p-[1vh]"
                maxLength={"255"}
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
              ></textarea>
              <h6>Envie até 5 anexos que possam ajudar a comprovar a cobrança indevida</h6>
              <p className="text-red-700">Formatos aceitos: arquivos de imagem, texto, excel e pdf</p>
              <button
                className="w-full flex items-center justify-center bg-green-600 text-white
                rounded-lg py-[1vh] gap-[4vh] hover:bg-green-500 font-lato-bold"
                type="file"
                multiple
                onClick={() => fileInputRef.current.click()}
              >
                Adicionar Anexo
                <FaPaperclip />
              </button>
              <input type="file" onChange={handleUpload} ref={fileInputRef} hidden />
              <div>
                <h6>Arquivos adicionados:</h6>
                <div className="flex justify-center flex-wrap gap-[0.5vh]">
                  {arquivosContestacao.length > 0 &&
                    arquivosContestacao.map((file, index) => {
                      //console.log(file)
                      if (file[0].type.startsWith("image"))
                        return (
                          <div className="w-1/4 border-[0.2vh] border-black rounded-md p-[0.5vh]">
                            <div className="flex justify-between">
                              <p className="font-lato break-all">{file[0].name}</p>
                              <button onClick={() => removeFile(index)}>
                                <FaTimesCircle className="text-red-500" />
                              </button>
                            </div>
                            <img src={arquivosContestacaoURL[index]} alt={file[0].name} />
                          </div>
                        );
                      if (file[0].type.startsWith("application/pdf"))
                        return (
                          <div className="w-1/4 border-[0.2vh] border-black rounded-md p-[0.5vh]">
                            <div className="flex justify-between">
                              <p className="font-lato break-all">{file[0].name}</p>
                              <button onClick={() => removeFile(index)}>
                                <FaTimesCircle className="text-red-500" />
                              </button>
                            </div>
                            <FaFilePdf
                              className="bg-white text-red-500 w-full
                            text-[10vh]"
                            />
                          </div>
                        );
                      if (file[0].type.startsWith("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))
                        return (
                          <div className="w-1/4 border-[0.2vh] border-black rounded-md p-[0.5vh]">
                            <div className="flex justify-between">
                              <p className="font-lato break-all">{file[0].name}</p>
                              <button onClick={() => removeFile(index)}>
                                <FaTimesCircle className="text-red-500" />
                              </button>
                            </div>
                            <FaFileExcel
                              className="bg-white text-green-600 w-full
                          text-[10vh]"
                            />
                          </div>
                        );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ConstestacaoDialog;
